import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { default as ngLang } from '@angular/common/locales/en';
import { APP_INITIALIZER, ApplicationConfig, EnvironmentProviders, importProvidersFrom, Provider } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  provideRouter,
  RouterFeatures,
  withComponentInputBinding,
  withHashLocation,
  withRouterConfig,
  withViewTransitions
} from '@angular/router';
import { I18NService, provideStartup } from '@bocore';
import { AlainProvideLang, en_US as delonLang, provideAlain } from '@delon/theme';
import { enUS as dateLang } from 'date-fns/locale';
import { NzConfig, provideNzConfig } from 'ng-zorro-antd/core/config';
import { en_US as zorroLang } from 'ng-zorro-antd/i18n';

import { provideReuseTabConfig, ReuseTabMatchMode } from '@delon/abc/reuse-tab';
import { AlainConfig } from '@delon/util';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { AppConfig, environment } from 'projects/bo/src/environments/environment';
import { ICONS } from '../style-icons';
import { ICONS_AUTO } from '../style-icons-auto';
import { APP_CONFIG_TOKEN } from './core/services/abstracts/app-config.abstract';
import { BROADCAST_NAME_SERVICE_TOKEN, BROADCAST_SERVICE_TOKEN, BroadcastService } from './core/services/helpers/broadcast.service';
import { HttpInterceptorService } from './core/services/implements/http-interceptor.service';
import { getAppRoutes } from './routes/routes';

const defaultLang: AlainProvideLang = {
  abbr: 'en-US',
  ng: ngLang,
  zorro: zorroLang,
  date: dateLang,
  delon: delonLang
};

const alainConfig: AlainConfig = {
  pageHeader: { homeI18n: 'app.home' }
};

const ngZorroConfig: NzConfig = {};

const routerFeatures: RouterFeatures[] = [withComponentInputBinding(), withRouterConfig({ canceledNavigationResolution: 'computed' })];
if (environment.useHash) routerFeatures.push(withHashLocation());
if (environment.platform === 'web') routerFeatures.push(withViewTransitions());

export const providers: Array<Provider | EnvironmentProviders> = [
  provideHttpClient(withInterceptorsFromDi()),
  provideAnimations(),
  provideRouter(getAppRoutes(), ...routerFeatures),
  provideAlain({ config: alainConfig, defaultLang, i18nClass: I18NService, icons: [...ICONS_AUTO, ...ICONS] }),
  provideNzConfig(ngZorroConfig),
  provideStartup(),
  provideReuseTabConfig({ mode: ReuseTabMatchMode.URL }),
  provideIonicAngular({ experimentalCloseWatcher: true }),
  importProvidersFrom(GooglePlaceModule),
  {
    provide: APP_INITIALIZER,
    useFactory: (appconfig: AppConfig) => {
      return () => appconfig.loadConfig();
    },
    deps: [AppConfig],
    multi: true
  },
  {
    provide: APP_CONFIG_TOKEN,
    useExisting: AppConfig,
    deps: [HttpClient]
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: HttpInterceptorService,
    multi: true
  },
  {
    provide: BROADCAST_SERVICE_TOKEN,
    useClass: BroadcastService,
    deps: [BROADCAST_NAME_SERVICE_TOKEN]
  },
  {
    provide: BROADCAST_NAME_SERVICE_TOKEN,
    useValue: 'sf-bo-broadcast-service'
  },
  ScreenOrientation
];

export const appConfig: ApplicationConfig = {
  providers: providers
};
